import React from 'react'
import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../lib/AuthContext'

export default function AdminLayout() {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  return (
    <>
      <header>
        <div className="logo"><span>Rebound</span> <span style={{ color: 'var(--muted)', fontWeight: 400, fontSize: 12 }}>Admin Panel</span></div>
        <nav>
          <NavLink to="/admin" end className={({ isActive }) => isActive ? 'active' : ''}>Workshops</NavLink>
          <NavLink to="/" className={() => ''} style={{ color: 'var(--muted)' }}>← Back to App</NavLink>
          <button className="nav-btn" onClick={async () => { await signOut(); navigate('/login') }} style={{ marginLeft: 8 }}>Sign Out</button>
        </nav>
      </header>
      <main><Outlet /></main>
    </>
  )
}
